import ThemeProvider from './ThemeProvider.tsx';
import Theme, { ImportTheme } from './types/Theme.types.ts';
import {
  Breakpoint,
  BreakpointKey,
  Breakpoints,
} from './types/breakpoints.type.ts';
import {
  ColorKey,
  ColorPalette,
  Colors,
  ColorShade,
  ColorValue,
} from './types/color.type.ts';
import { AlgorithmKey } from './types/algorithm.type.ts';
import GlobalStyles from '@template/theme/GlobalStyles.ts';
import breakpoints from '@template/theme/breakpoints.ts';

export {
  ThemeProvider,
  GlobalStyles,
  breakpoints,
  type Theme,
  type Breakpoints,
  type Colors,
  type ColorKey,
  type ColorShade,
  type ColorValue,
  type ColorPalette,
  type ImportTheme,
  type Breakpoint,
  type BreakpointKey,
  type AlgorithmKey,
};
